module.exports = __webpack_public_path__ + "static/media/dyk.96e432a8.jpg";